import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { tap } from 'rxjs/operators';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService, private router: Router) { }
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.showLoader();
    request = request.clone({
      setHeaders: {
        'x-access-token': `${localStorage.getItem('authToken')}`,
      }
    });

    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        this.hideLoader();
      }
    },
      error => {
        this.hideLoader();
        if (error.status === 401) {
          this.router.navigate(['../auth']);
        }
      }),
    );
  }
  private showLoader(): void {
    this.loaderService.show();
  }
  private hideLoader(): void {
    setTimeout(() => {
      this.loaderService.hide();
    }, 500);
  }
}
